













































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { UserService } from './UserService'
import UserPanel from '@/components/UserPanel.vue'

@Component({
  name: 'App',
  components: { UserPanel }
})
export default class App extends Vue {
  userContext: TwitchUserInterface | null = null
  isLoading = true

  navigation = [
    {
      to: '/',
      icon: 'fas fa-home',
      title: 'Home'
    },
    {
      to: '/grammar',
      icon: 'fas fa-book',
      title: 'Documentation'
    },
    {
      to: '/channels',
      icon: 'fas fa-list',
      title: 'Channels'
    }
  ]

  mounted () {
    UserService.getCurrentUser().then(response => {
      this.userContext = response
      this.isLoading = false
    }).catch(reason => {
      this.userContext = reason
      this.isLoading = false
    })
  }
}
